import { render, staticRenderFns } from "./TextAreaElement.vue?vue&type=template&id=1b941090&"
import script from "./TextAreaElement.vue?vue&type=script&lang=ts&"
export * from "./TextAreaElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports